import { getJson, postJson, withDone, withValidate } from '@rad/utility/http';
export const lookupMeta = (lookup) => {
    try {
        return JSON.parse(lookup.meta);
    }
    catch {
        return {};
    }
};
export const getLookups = () => getJson('/api/lookups');
export const createLookup = (lookup) => withDone(withValidate(postJson('/api/lookups', lookup)))();
export const updateLookup = (originalValue, lookup) => withDone(withValidate(postJson(`/api/lookups/${encodeURIComponent(lookup.kind)}/${encodeURIComponent(originalValue)}`, lookup)))();
